<template>
  <main>
    <!-- <page-title /> -->
    <router-view />
  </main>
</template>

<script>
import PageTitle from "@/components/main/PageTitle";
export default {
  name: 'InMain',
  components:{
    PageTitle
  },
  props: ['currentMenu']
}
</script>

<style scoped>
main {
  width: calc(100% - 240px);
  /* margin-bottom:15px; */
  padding:20px;
  box-sizing:border-box
}
</style>
